import { Route, Routes as RouterRoutes, BrowserRouter, Navigate } from 'react-router-dom';
import MissingLicense from 'containers/MissingLicense';
import ContainerLayout from 'components/layout/ContainerLayout';
import SheetContainer from 'components/sheet-container';
import WorksheetMakerContainer from 'components/worksheet-maker-container';
import WorksheetMenu from 'components/worksheet-menu';

const Routes = () => {
  return (
    <BrowserRouter>
      <RouterRoutes>
        <Route path="/no-access" element={<MissingLicense />} />
        <Route
          path="/:sectionId"
          element={
            <ContainerLayout>
              <WorksheetMakerContainer>
                <WorksheetMenu />
              </WorksheetMakerContainer>
            </ContainerLayout>
          }
        />
        <Route
          path="/:sectionId/:sheetId"
          element={
            <WorksheetMakerContainer>
              <SheetContainer />
            </WorksheetMakerContainer>
          }
        />
        <Route path="/" element={<Navigate to={'/0'} />} />
      </RouterRoutes>
    </BrowserRouter>
  );
};

export default Routes;
